import UltMeta, { Meta } from "./UltMeta/index";

class CorpusState extends UltMeta {
    INCOMPLETE = new Meta(0, "未完成");
    COMPLETE = new Meta(1, "已完成");
}

export const CORPUS_STATE = new CorpusState();
